export default __webpack_public_path__ + "static/media/SomethingWentWrong.9b3ecbec.svg";